import { APPS_ROUTES } from '../../screens/apps/routes';
import iconImage from '../../assets/images/numbcrunch/app-icon.png';

// Product facts: Guesser docs/gameplay.md, CHANGELOG.md and PRIVACY.md at
// 1167ee80886102f4823b0cc17a8dc8a633d4c98d. The source repository is private.
export const numbcrunch = {
  id: 'numbcrunch',
  name: 'NumbCrunch',
  iconImage,
  tagline: 'Three digits. One hidden number.',
  summary: 'An Android number-guessing game. Use the clues to uncover a secret code, or challenge a friend on the same device.',
  platform: 'Android',
  packageName: 'io.keval.apps.numbcrunch',
  operator: 'Keval Langalia',
  contactEmail: 'hello@keval.io',
  route: APPS_ROUTES.numbcrunch,
  privacyRoute: APPS_ROUTES.numbcrunchPrivacy,
  termsRoute: APPS_ROUTES.numbcrunchTerms,
  badges: [
    { label: 'Android', variant: 'accent' },
    { label: 'Play offline', variant: 'river' },
    { label: 'No ads or purchases', variant: 'outline' },
  ],
  release: {
    label: 'In testing',
    detail: 'NumbCrunch is in internal testing. A public Google Play download is not available from this page yet.',
    playStoreUrl: null,
  },
  features: [
    {
      id: 'three-digit-puzzle',
      title: 'Follow the clues',
      body: 'Find a code made of three different digits. R means a correct digit in the right position; W means a correct digit in the wrong position. SMYLE means none of your digits match. Keep guessing until you find all three.',
    },
    {
      id: 'two-modes',
      title: 'Play solo or with a friend',
      body: 'Single Player picks a secret code for you. In Double Player, a friend hides a code on the same device before handing it over for you to solve.',
    },
    {
      id: 'learn-by-playing',
      title: 'Learn by playing',
      body: 'An interactive tutorial lets you practice the clues before a round. Guesses are unlimited, and a code can start with zero.',
    },
    {
      id: 'offline-play',
      title: 'Settle into a round',
      body: 'Warm wooden game artwork, background music and sound effects accompany each puzzle. Music and sounds can be switched off, and the game works without internet access.',
    },
  ],
  privacyHighlights: [
    'The app has no internet permission, accounts, advertising, analytics or in-app purchases.',
    'Game settings, tutorial progress and round information stay on your device; no personal information is sent to the developer.',
    'Android may include settings and tutorial progress in your device backup. You can manage backups in Android settings.',
  ],
  faq: [
    {
      question: 'Is Double Player online multiplayer?',
      answer: 'No. Two people share one device: one hides the number, then the other tries to uncover it.',
    },
    {
      question: 'Do I need an account or an internet connection?',
      answer: 'No. NumbCrunch has no accounts and plays entirely on your device without internet access.',
    },
    {
      question: 'How do I remove the game’s saved information?',
      answer: 'Clear the app’s storage in Android settings or uninstall the app. Android-managed device backups can be controlled separately in your device settings.',
    },
  ],
};
